<template>
  <v-flex mb-2 xs12>
    <div v-if='mode == "finished"'>
        Complete
    </div>
    <div v-if='mode == "error"'>
        <v-alert :value="true" type="error" >
            {{error_message}}
        </v-alert>
    </div>
    <div v-if='mode == "confirm"' style='background: #ccc'>
        <b>Is this the right person?</b>
        <br/>
        {{ attendee.full_name }} / {{ attendee.native_name }} / {{ attendee.nickname }}
        <br/>

        <v-alert
          :value="true"
          type="info"
            v-if="!attendee.active" 
        >
          Final Confirmation -- Are you sure?
          <br/>
          양도 확실해요?
        </v-alert>


        <v-btn xs4 color='success' @click="confirm">Transfer Ticket</v-btn>
        <v-btn xs4 color='error' @click="cancel_confirm">Cancel</v-btn>
    </div>
    <div v-if='mode == "lookup"'>
        <v-form ref="form">
          <v-layout row wrap  justify-center>
            <v-flex xs6 sm6 md3>
              <v-text-field
                outline
                class='display_upcase'
                v-model="code"
                :rules="[rules.reasonable_length]"
                :error-messages="code_error_messages"
                label="Transfer Code"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 sm6 md3>
              <v-btn color="primary" @click="lookup">Transfer Ticket</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
    </div>
  </v-flex>
</template>

<script>
import {mapState} from 'vuex';
import {fetcher} from '@/fetcher';

export default {
  props: ['ticket'],
  data: () => ({
    mode: 'lookup',
    event: {},
    ready: false,
    attendee: {},
    code: '',
    excode: '238FJHEP',
    code_error_messages: [],
    error_message: '',
    rules: {
      required: value => !!value || 'Required.',
      reasonable_length: value =>
        (value.length >= 8 && value.length <= 10) || 'Between 8-10 characters',
    },
    finished: false,
  }),
  beforeMount: async function() {},
  computed: {
    ...mapState(['myprofile', 'events', 'attendees']),
  },
  watch: {},
  methods: {
    lookup() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      fetcher
        .get('/myprofile/transfer_code_lookup', {
          params: {
            full_transfer_code: this.$data.code,
            event_id: this.$route.params.event_id,
            ticket_id: this.ticket.id, 
          },
        })
        .then(res => {
          if (res.data.success) {
            this.$data.code_error_messages = [];
            this.$data.mode = 'confirm';
            this.$data.attendee = res.data.attendee;
          } else {
            this.$data.code_error_messages = res.data.message;
          }
        });
    },
    cancel_confirm() {
      this.$data.mode = 'lookup';
    },
    confirm() {
      var that = this;
      fetcher
        .post('/myprofile/transfer_to_code', {
          full_transfer_code: this.$data.code,
          event_id: this.$route.params.event_id,
          ticket_id: this.ticket.id, 
        })
        .then(res => {
          if (res.data.success) {
            this.$data.mode = 'finished';
            this.$store.dispatch('loadAttendees');
            setTimeout(() => {
              this.$data.mode = 'lookup';
            }, 1000);
          } else {
            this.$data.error_message = res.data.message;
            this.$data.mode = 'error';
            setTimeout(() => {
              this.$data.mode = 'lookup';
            }, 2000);
          }
        });
    },
  },
};
</script>

<style>
.display_upcase input {
  text-transform: uppercase;
}
</style>
